export enum PageTimePeriod {
    CURRENT_MONTH = 'currentMonth',
    LAST_YEAR = 'lastYear'
}
